export default {
    fields: {
        name: {
            label: 'Name',
            placeholder: 'Enter company name',
        },
        pib: {
            label: 'PIB',
            placeholder: 'Enter company PIB',
        },
        address: {
            label: 'Address',
            placeholder: 'Enter address',
        },
        subDomain: {
            label: 'SubDomain',
            placeholder: 'Enter SubDomain',
        },
        city: {
            label: 'City',
            placeholder: 'Select a city',
        },
        country: {
            label: 'Country',
            placeholder: 'Select a country',
            SERBIA: 'Serbia',
            BOSNIA: 'Bosnia and Herzegovina',
        },
        theme: {
            label: 'Theme',
            placeholder: 'Select a theme',
        },
    },
    price_increase: 'By activating subdomain, the price will increse by {subdomainPrice}',
    subdomain_removal:
        'Your subdomain {subdomain} in scheduled for removal on {removalDate} and it will be removed on the first in the following month',
    start_for_free: 'Start for free',
    choose_package: 'Choose package',
    update_company_heading: 'Are you sure you want to update your company settings?',
    deactivate_company_heading: 'Are you sure you want to deactive your company?',
    no_companies: 'You currently have no created companies. Would you like to do that now?',
}
